(function () {
    'use strict';

    angular
        .module('blocks.directives')
        .directive('spFormAutoFillFix', spFormAutoFillFix);

    spFormAutoFillFix.$inject = ['$timeout'];
    /* @ngInject */
    function spFormAutoFillFix($timeout) {
        var directive = {
            restrict: 'A',
            link: link
        };

        return directive;

        function link(scope, element, attrs, ctrl) {
            // Fixes Chrome bug: https://groups.google.com/forum/#!topic/angular/6NlucSskQjY
            element.prop('method', 'POST');

            if (attrs.ngSubmit) {
                $timeout(function () {
                    
                    element.unbind('submit').submit(function (e) {
                        e.preventDefault();
                        element.find('input, textarea, select').trigger('input').trigger('change').trigger('keydown');
                        scope.$apply(attrs.ngSubmit);
                    });
                }, 0);
            }
        }
    }
})();
